module.exports = __webpack_public_path__ + "img/portrait-one.20d464ff.png";